import QuickChatView from './QuickChatView';

export default QuickChatView;
